import React from "react";

const OverallDelay = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3578_14)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#FFE4E6" />
    </g>
    <path
      d="M20.2554 13.4281H18.122C17.8874 13.4281 17.6953 13.2361 17.6953 13.0014C17.6953 12.7668 17.8873 12.5747 18.122 12.5747H19.8287V10.8681C19.8287 10.6335 20.0207 10.4414 20.2554 10.4414C20.4901 10.4414 20.6821 10.6334 20.6821 10.8681V13.0014C20.682 13.2361 20.49 13.4281 20.2554 13.4281Z"
      fill="#961B01"
    />
    <path
      d="M15.9882 21.5349C14.5076 21.5349 13.1146 20.959 12.067 19.9093C11.0175 18.8618 10.4414 17.4689 10.4414 15.9882C10.4414 14.5075 11.0174 13.1146 12.067 12.067C13.1145 11.0175 14.5075 10.4414 15.9882 10.4414C17.8079 10.4414 19.5765 11.3268 20.6005 12.7518C20.7392 12.9438 20.6944 13.2105 20.5024 13.347C20.3104 13.4856 20.0437 13.4408 19.9072 13.2489C19.041 12.0436 17.5392 11.2948 15.9884 11.2948C13.4007 11.2948 11.2951 13.4005 11.2951 15.9881C11.2951 18.5758 13.4007 20.6814 15.9884 20.6814C18.576 20.6814 20.6816 18.5757 20.6816 15.9881C20.6816 15.5913 20.6325 15.1967 20.5344 14.8148C20.4746 14.5865 20.6133 14.354 20.8416 14.2943C21.0699 14.2345 21.3024 14.3732 21.3621 14.6015C21.4773 15.0516 21.537 15.5188 21.537 15.9882C21.537 17.4687 20.9611 18.8618 19.9114 19.9093C18.8619 20.9588 17.4689 21.5349 15.9882 21.5349L15.9882 21.5349Z"
      fill="#961B01"
    />
    <path
      d="M18.1208 16.412H16.8408C16.6061 16.412 16.4141 16.22 16.4141 15.9853C16.4141 15.7506 16.606 15.5586 16.8408 15.5586H18.1208C18.3554 15.5586 18.5475 15.7506 18.5475 15.9853C18.5475 16.2199 18.3555 16.412 18.1208 16.412Z"
      fill="#961B01"
    />
    <path
      d="M15.9892 15.5618C15.7545 15.5618 15.5625 15.3699 15.5625 15.1351V12.5751C15.5625 12.3405 15.7545 12.1484 15.9892 12.1484C16.2238 12.1484 16.4159 12.3404 16.4159 12.5751V15.1351C16.4159 15.3698 16.2238 15.5617 15.9892 15.5617V15.5618Z"
      fill="#961B01"
    />
    <path
      d="M15.987 17.2709C15.2809 17.2709 14.707 16.6971 14.707 15.9909C14.707 15.2848 15.2809 14.7109 15.987 14.7109C16.6932 14.7109 17.267 15.2848 17.267 15.9909C17.267 16.6971 16.6932 17.2709 15.987 17.2709ZM15.987 15.5642C15.7524 15.5642 15.5603 15.7562 15.5603 15.9909C15.5603 16.2256 15.7523 16.4176 15.987 16.4176C16.2217 16.4176 16.4137 16.2257 16.4137 15.9909C16.4137 15.7563 16.2217 15.5642 15.987 15.5642Z"
      fill="#961B01"
    />
    <defs>
      <filter
        id="filter0_d_3578_14"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3578_14"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3578_14"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default OverallDelay;
